import { TrainingTypeEnum } from "../enums/training.enums";
import { SessionItemFormatEnum, SessionItemTypeEnum } from "~/utils/enums/session-items.enums";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";
import type { IOpts } from "~/utils/interfaces/common-interfaces";

export const SessionItemsFormats: IOpts<SessionItemFormatEnum>[] = [
  {
    name: SessionItemFormatEnum.ONLINE,
    value: "eLearning",
    type: "light_orange",
  },
  {
    name: SessionItemFormatEnum.IN_PERSON,
    value: "Classe",
    type: "light_purple",
  },
  {
    name: SessionItemFormatEnum.MIXED,
    value: "Mixte",
    type: "light_purple",
  },
];

/**
 * ADD Internal wich is a training_type on filter TYPE. ISNT SI type, actually internal = individual. So we need to filter on training type
 */
export const SessionItemsTypes: IOpts<TrainingTypeEnum | SessionItemTypeEnum>[] = [
  {
    name: SessionItemTypeEnum.INDIVIDUAL,
    value: "Inter",
    type: "grey",
    icon: "/icons/generic/indiv.svg",
  },
  {
    name: SessionItemTypeEnum.GROUP,
    value: "Intra",
    type: "grey",
    icon: "/icons/generic/group.svg",
  },
  {
    name: TrainingTypeEnum.INTERNAL,
    value: "Interne",
    type: "grey",
    icon: "graduation_cap_on_v2",
  },
];

export const SessionItemFormats: IOpts<SessionItemFormatEnum>[] = [
  {
    name: SessionItemFormatEnum.ONLINE,
    value: "eLearning",
    type: "light_orange",
  },
  {
    name: SessionItemFormatEnum.IN_PERSON,
    value: "Classe",
    type: "light_blue",
  },
  {
    name: SessionItemFormatEnum.MIXED,
    value: "Mixte",
    type: "light_purple",
  },
];

/**
 * Training-level format → the tag a training card shows: its FR label and the icon the design system
 * gives that format (cf. the internal-training choice modal).
 */
export const TrainingFormatTags: Record<SessionItemFormatEnum, { value: string; type: ColorsTypeEnum; logo: string }> =
  {
    [SessionItemFormatEnum.IN_PERSON]: { value: "Classe", type: ColorsTypeEnum.LIGHT_GREY, logo: "presential" },
    [SessionItemFormatEnum.ONLINE]: { value: "eLearning", type: ColorsTypeEnum.LIGHT_GREY, logo: "web" },
    [SessionItemFormatEnum.MIXED]: { value: "Mixte", type: ColorsTypeEnum.LIGHT_GREY, logo: "blended" },
  };

export const SessionStatus: IOpts<string>[] = [
  {
    name: "pending_employee",
    value: "Invitation envoyée",
    type: "light_orange",
  },
  {
    name: "pending_provider",
    value: "En attente prestataire",
    type: "light_red",
  },
  {
    name: "pending_invitation",
    value: "En attente invitation",
    type: "light_red",
  },
  {
    name: "no_show",
    value: "Absent",
    type: "light_grey",
  },
  {
    name: "registered",
    value: "Inscrit",
    type: "light_green",
  },
  {
    name: "in_progress",
    value: "En cours",
    type: "light_green",
  },
  {
    name: "completed",
    value: "Terminé",
    type: "light_green",
  },
  {
    name: "canceled",
    value: "Déplanifié",
    type: "light_red",
  },
  {
    name: "not_completed",
    value: "Absent",
    type: "grey",
  },
  {
    name: "on_hold",
    value: "En attente",
    type: "grey",
  },
  {
    name: "pending_provider", // todo: what to map with ?
    value: "pending_provider",
    type: "grey",
  },
  {
    name: "to_complete",
    value: "À compléter",
    type: "light_purple",
  },
  {
    name: "to_validate",
    value: "À valider",
    type: "light_blue",
  },
];

export const SessionFormats = [
  {
    name: "online",
    value: "eLearning",
  },
  {
    name: "in_person",
    value: "Classe",
  },
  {
    name: "mixed",
    value: "Mixte",
  },
];
